import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'Advantages' })((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 64,
        alignSelf: 'stretch',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            gap: 40
        }
    },
    items: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 20,
        alignSelf: 'stretch',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            gridTemplateColumns: '1fr'
        }
    }
}));
